module.exports = __webpack_public_path__ + "static/media/apartment11.c5f9f69b.jpg";